import { useState, useEffect } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { Box, Grid, Tooltip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, RadioGroup, FormControlLabel, Radio, FormControl } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ProductListContainer from './ProductListContainer';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import FieldView2 from 'core/components/layout/FieldView2';
import { setProductViewproductModal } from 'store/slice/PharmaSlice'; 
import {setSelectedPharmaorderId, setSelectedProductId} from 'store/slice/PharmaSlice';
import { updateProductObj } from 'store/slice/PharmaSlice';

import ViewproductActionModal from 'components/product/action/viewproduct/ViewproductActionModal';
import {editMRPAPI, updateProductStatusAPI} from 'api/OmsOrdermgmtWebServices';
import { updatePharmaorderObj } from 'store/slice/PharmaSlice';
import { userprofileInfo } from 'store/slice/HeaderSlice';



export default function ProductExpandCollapseBodyProductInfo({productObj}) {
    const [expanded, setExpanded] = useState(false);
    const [editMRPOpen, setEditMRPOpen] = useState(false);
    const [mrpValue, setMrpValue] = useState('');
    const [isUpdating, setIsUpdating] = useState(false);
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [savedMRPValue, setSavedMRPValue] = useState('');
    const [apiError, setApiError] = useState('');
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
    const [selectedAction, setSelectedAction] = useState(''); // 'cancel' or 'hold'
    const [isStatusUpdating, setIsStatusUpdating] = useState(false);
    const [reason, setReason] = useState(''); // Add reason state
    const dispatch = useDispatch();
    const {userprofileInfo} = useSelector((state) => state.headerslice);

    // Get pharmaorder information from Redux store
    const {pharmaorderObj} = useSelector((state) => state.pharmaslice.pharmaorderDashboard);

    const handleViewPDF = () => {
        dispatch(setSelectedPharmaorderId(productObj.orderid));
        dispatch(setSelectedProductId(productObj.id));
        dispatch(setProductViewproductModal(true));
    };

    const handleEditMRP = () => {
        // Initialize with current MRP value
        setMrpValue(productObj.mrptext || '');
        setEditMRPOpen(true);
        setUpdateSuccess(false);
        setApiError(''); // Clear any previous errors
    };

    const handleSaveMRP = () => {
        if (!mrpValue.trim()) {
            return; // Don't save empty values
        }

        setIsUpdating(true);
        setApiError(''); // Clear any previous errors

        editMRPAPI(
            { 
                "productId": productObj.id,
                "mrp": mrpValue 
            },
            (apiResponse) => {
                console.log('MRP updated successfully:', apiResponse);
                setIsUpdating(false);
                setUpdateSuccess(true);
                setSavedMRPValue(mrpValue);
                dispatch(updateProductObj(apiResponse.productInfo));
            },
            (error) => {
                console.error('Error updating MRP:', error);
                setIsUpdating(false);
                setApiError(error || 'Failed to update MRP. Please try again.');
            }
        );
    };

    const handleEditAgain = () => {
        setUpdateSuccess(false);
        setMrpValue(savedMRPValue);
        setApiError(''); // Clear errors when editing again
    };

    const handleCloseDialog = () => {
        setEditMRPOpen(false);
        setUpdateSuccess(false);
        setMrpValue('');
        setSavedMRPValue('');
        setApiError(''); // Clear errors when closing
    };

    const handleCancelOrder = () => {
        setCancelDialogOpen(true);
    };

    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);
        setReason(''); // Clear reason when closing base dialog
    };

    const handleActionClick = (action) => {
        // Validate that reason is provided
        if (!reason.trim()) {
            return; // Don't proceed without reason
        }
        
        setSelectedAction(action);
        setConfirmationDialogOpen(true);
    };

    const handleConfirmationClose = () => {
        setConfirmationDialogOpen(false);
        setSelectedAction('');
        // Don't clear reason here - keep it in the base dialog
    };

    const handleConfirmAction = () => {
        setIsStatusUpdating(true);
        
        // Determine the status ID based on action
        const status = selectedAction === 'cancel' ? 10 : 9;
        
        const payload = {
            "productId": productObj.id,
            status: status,
            reason: reason.trim() // Include reason in payload
        };

        updateProductStatusAPI(
            payload,
            (apiResponse) => {
                console.log('Product status updated successfully:', apiResponse);
                setIsStatusUpdating(false);
                setConfirmationDialogOpen(false);
                setSelectedAction('');
                setReason(''); // Clear reason after success
                // Update the product object in Redux store
                dispatch(updateProductObj(apiResponse.productInfo));
                dispatch(updatePharmaorderObj(apiResponse.pharmaorderInfo));
                // Keep the base dialog open - base dialog stays visible
            },
            (error) => {
                console.error('Error updating product status:', error);
                setIsStatusUpdating(false);
                setConfirmationDialogOpen(false);
                setSelectedAction('');
                // Don't clear reason on error - let user try again
            }
        );
    };

    const getActionDetails = () => {
        if (selectedAction === 'cancel') {
            return {
                message: 'Are you Sure to cancel this product from the Order?',
                buttonText: 'Yes, Cancel',
                buttonColor: 'error'
            };
        } else {
            return {
                message: 'Are you Sure to put this product on Hold?',
                buttonText: 'Yes, Put on Hold',
                buttonColor: 'warning'
            };
        }
    };

    return (

        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{ gap: 2 }}
      >
            {/* Product Properties Box */}
            <Grid item lg={10.5} xs={10}>
                <Box sx={{ 
                    backgroundColor: 'white', 
                    borderRadius: 2, 
                    p: 2, 
                    border: '1px solid #e0e0e0',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
                        <Grid item lg={2} xs={6}><FieldView2 color="white" label="Brand Name" value={productObj.brandname !== null && productObj.brandname !== undefined ? productObj.brandname : 'NOT KNONWN'} /></Grid>   
                        <Grid item lg={1} xs={6}><FieldView2 color="white" label="Rate" value={productObj.rate !== null && productObj.rate !== undefined ? productObj.rate : 'NOT KNONWN'} /></Grid>
                        <Grid item lg={1} xs={6}><FieldView2 color="white" label="MRP" value={productObj.mrptext !== null && productObj.mrptext !== undefined ? productObj.mrptext : 'NOT KNONWN'} /></Grid>
                        <Grid item lg={1} xs={6}><FieldView2 color="white" label="Boxes" value={productObj.batchsize !== null && productObj.batchsize !== undefined ? productObj.batchsize : 'NOT KNONWN'} /></Grid>
                        <Grid item lg={1} xs={6}><FieldView2 color="white" label="Payment" value={productObj.cr_cash !== null && productObj.cr_cash !== undefined ? productObj.cr_cash : 'NOT KNONWN'} /></Grid>
                        <Grid item lg={2} xs={6}><FieldView2 color="white" label="Packaging" value={productObj.packagingtypename !== null && productObj.packagingtypename !== undefined ? productObj.packagingtypename : 'NOT KNONWN'} /></Grid>
                        
                        {(productObj.formname==="Tablet") || productObj.formname==="Capsul" || productObj.formname==="Sachet"?
                        <>
                            <Grid item lg={2} xs={6}><FieldView2 color="white" label={productObj.formname==="Sachet"?'Sachets per Box' :'Strip(s) per Box'} value={productObj.packagingsize1name !== null && productObj.packagingsize1name !== undefined ? productObj.packagingsize1name : 'NOT KNONWN'} /></Grid>
                            <Grid item lg={2} xs={6}><FieldView2 color="white" label={productObj.formname==="Sachet"?'GRM(s) per Sachet' :'Item(s) per Strip'} value={productObj.packagingsize2name !== null && productObj.packagingsize2name !== undefined ? productObj.packagingsize2name : 'NOT KNONWN'} /></Grid>
                        </>
                      :<>
                          <Grid item lg={2} xs={6}><FieldView2 color="white" label={productObj.formname==="Liquid" || productObj.formname==="Lotion" || productObj.formname==="Gargle"?'ML(s) per Packaing':'GRM(s) per Packing'}  value={productObj.packagingsize2name !== null && productObj.packagingsize2name !== undefined ? productObj.packagingsize2name : 'NOT KNONWN'} /></Grid>
                      </>}
                        
                        <Grid item lg={12} xs={12}><FieldView2 color="white" label="Remarks" value={productObj.remarks !== '' ? productObj.remarks : 'NO Remarks'} /></Grid>
                    </Grid>
                </Box>
            </Grid>

            {/* Action Icons Box */}
            <Grid item lg={1} xs={1}>
                <Box sx={{ 
                    backgroundColor: 'white', 
                    borderRadius: 2, 
                    p: 2, 
                    border: '1px solid #e0e0e0',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100px',
                    gap: 1
                }}>
                    {/* PDF View Icon - Always visible */}
                    <Tooltip title="View PO" arrow>
                        <IconButton
                            onClick={handleViewPDF}
                            size="medium"
                            sx={{
                                color: 'primary.main',
                                backgroundColor: 'primary.lighter',
                                borderRadius: '12px',
                                '&:hover': {
                                    backgroundColor: 'primary.main',
                                    color: 'white',
                                    transform: 'scale(1.05)',
                                },
                                p: 1.5,
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            <PictureAsPdfIcon fontSize="medium" />
                        </IconButton>
                    </Tooltip>

                    {/* Edit MRP Icon - Hide if overallstatusid is 9 or 10 OR user is not PHARMA_OMS_MANAGER or PHARMA_OMS_ADMIN */}
                    {productObj.overallstatusid !== 9 && productObj.overallstatusid !== 10 && (userprofileInfo.rolename === 'PHARMA_OMS_MANAGER' || userprofileInfo.rolename === 'PHARMA_OMS_ADMIN') && (
                        <Tooltip title="Edit MRP" arrow>
                            <IconButton
                                onClick={handleEditMRP}
                                size="medium"
                                sx={{
                                    color: 'warning.main',
                                    backgroundColor: 'warning.lighter',
                                    borderRadius: '12px',
                                    '&:hover': {
                                        backgroundColor: 'warning.main',
                                        color: 'white',
                                        transform: 'scale(1.05)',
                                    },
                                    p: 1.5,
                                    transition: 'all 0.2s ease-in-out'
                                }}
                            >
                                <EditIcon fontSize="medium" />
                            </IconButton>
                        </Tooltip>
                    )}

                    {/* Cancel Order Icon - Hide if overallstatusid is 9 or 10 OR user is not PHARMA_OMS_MANAGER or PHARMA_OMS_ADMIN */}
                    {productObj.overallstatusid !== 9 && productObj.overallstatusid !== 10 && (userprofileInfo.rolename === 'PHARMA_OMS_MANAGER' || userprofileInfo.rolename === 'PHARMA_OMS_ADMIN') && (
                        <Tooltip title="Cancel/ Hold Order" arrow>
                            <IconButton
                                onClick={handleCancelOrder}
                                size="medium"
                                sx={{
                                    color: 'error.main',
                                    backgroundColor: 'error.lighter',
                                    borderRadius: '12px',
                                    '&:hover': {
                                        backgroundColor: 'error.main',
                                        color: 'white',
                                        transform: 'scale(1.05)',
                                    },
                                    p: 1.5,
                                    transition: 'all 0.2s ease-in-out'
                                }}
                            >
                                <CancelIcon fontSize="medium" />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
            </Grid>

            {/* Edit MRP Dialog */}
            <Dialog
                open={editMRPOpen}
                onClose={handleCloseDialog}
                maxWidth="xs"
                
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 0 }}>
                    Edit MRP
                    <Button
                        onClick={handleCloseDialog}
                        sx={{ minWidth: 0, color: "grey.700" }}
                        aria-label="Close"
                    >
                        <CloseIcon />
                    </Button>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column' }}>
                        {/* Only show Current MRP when not in success state */}
                        {!updateSuccess && (
                            <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary', backgroundColor:'secondary.100', p:2, borderRadius: 1 }}>
                                Current MRP: {productObj.mrptext || 'Not Set'}
                            </Typography>
                        )}
                        
                        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                            {!updateSuccess ? (
                                <Grid container  sx={{ width: '100%' }}>
                                    {/* Input Field - Full Width */}
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="New MRP"
                                            placeholder="Enter new MRP (alphanumeric)"
                                            value={mrpValue}
                                            onChange={(e) => setMrpValue(e.target.value)}
                                            helperText="You can enter alphanumeric values (e.g., 250, 250.50, 250/- etc.)"
                                        />
                                    </Grid>
                                </Grid>
                            ) : (
                                <Box sx={{ 
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    p: 3,
                                    backgroundColor: 'success.lighter',
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'success.main',
                                    width: '100%'
                                }}>
                                    <CheckCircleIcon sx={{ fontSize: 48, color: 'success.main', mb: 2 }} />
                                    <Typography variant="h6" sx={{ color: 'success.dark', fontWeight: 600, mb: 1 }}>
                                        MRP Updated Successfully!
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: 'success.dark', mb: 2, textAlign: 'center' }}>
                                        The MRP has been updated to: <strong>{savedMRPValue}</strong>
                                    </Typography>
                                    <Button 
                                        onClick={handleEditAgain}
                                        variant="outlined"
                                        sx={{ 
                                            borderColor: 'success.main',
                                            color: 'success.main',
                                            '&:hover': {
                                                backgroundColor: 'success.main',
                                                color: 'white'
                                            }
                                        }}
                                    >
                                        Edit Again
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    {/* Error Message Display */}
                    {apiError && (
                        <Typography 
                            variant="body2" 
                            color="error" 
                            sx={{ 
                                mr: 2, 
                                flexGrow: 1,
                                backgroundColor: 'error.lighter',
                                p: 1.5,
                                borderRadius: 1,
                                border: '1px solid',
                                borderColor: 'error.main'
                            }}
                        >
                            {apiError}
                        </Typography>
                    )}
                    {!updateSuccess && (
                        <>
                            <Button onClick={handleCloseDialog}>Cancel</Button>
                            <Button 
                                onClick={handleSaveMRP} 
                                variant="contained"
                                disabled={!mrpValue.trim() || isUpdating}
                            >
                                {isUpdating ? 'Saving...' : 'Save'}
                            </Button>
                        </>
                    )}
                    {updateSuccess && (
                        <Button onClick={handleCloseDialog} variant="contained">
                            Close
                        </Button>
                    )}
                </DialogActions>
            </Dialog>

            {/* Cancel/Hold Order Selection Dialog */}
            <Dialog
                open={cancelDialogOpen}
                onClose={handleCancelDialogClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 0 }}>
                    Cancel / Hold Order
                    <Button
                        onClick={handleCancelDialogClose}
                        sx={{ minWidth: 0, color: "grey.700" }}
                        aria-label="Close"
                    >
                        <CloseIcon />
                    </Button>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{  display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {/* Product Information Block */}
                        <Box sx={{ 
                            backgroundColor: 'secondary.200', 
                            p: 1, 
                            borderRadius: 1,
                        }}>
                            <Grid container>
                                <Grid item lg={3} md={4} sm={4} xs={6}>
                                    <FieldView2 label="Order #" value={productObj.orderid || '-'} />
                                </Grid>
                                <Grid item lg={3} md={4} sm={4} xs={6}>
                                    <FieldView2 label="Brand Name" value={productObj.brandname || '-'} />
                                </Grid>
                                <Grid item lg={3} md={4} sm={4} xs={6}>
                                    <FieldView2 label="Party Name" value={productObj.partyname || '-'} />
                                </Grid>
                                
                                
                                <Grid item lg={8} md={12} sm={12} xs={12}>
                                    <FieldView2 label="Composition" value={productObj.title || '-'} />
                                </Grid>
                                <Grid item lg={3} md={4} sm={4} xs={12} sx={{backgroundColor:'primary.light', p:1, borderRadius:1, mt:1}}>
                                    <FieldView2 label="Current Status" value={productObj.statusname || '-'} />
                                </Grid>

                                
                            </Grid>
                        </Box>

                        {/* Reason Text Field */}
                        <Box>
                            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                                Reason for Action
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label="Reason"
                                placeholder="Please provide the reason for cancelling or putting this product on hold..."
                                value={reason}
                                onChange={(e) => {
                                    // Restrict to 200 characters
                                    if (e.target.value.length <= 200) {
                                        setReason(e.target.value);
                                    }
                                }}
                                required
                                helperText={`This field is required to proceed with any action (${reason.length}/200 characters)`}
                                error={reason.trim() === '' && (isStatusUpdating || selectedAction !== '')}
                                inputProps={{
                                    maxLength: 200
                                }}
                                sx={{
                                    '& .MuiInputBase-root': {
                                        '& textarea': {
                                            resize: 'vertical'
                                        }
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDialogClose}>Close</Button>
                    <Button 
                        onClick={() => handleActionClick('cancel')}
                        variant="contained"
                        color="error"
                        sx={{ mr: 1 }}
                        disabled={!reason.trim()}
                    >
                        Cancel Order
                    </Button>
                    <Button 
                        onClick={() => handleActionClick('hold')}
                        variant="contained"
                        color="warning"
                        disabled={!reason.trim()}
                    >
                        Put on Hold
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Confirmation Dialog */}
            <Dialog
                open={confirmationDialogOpen}
                onClose={handleConfirmationClose}
                maxWidth="xs"
                fullWidth
                sx={{ zIndex: 1400 }} // Ensure confirmation dialog appears above base dialog
            >
                <DialogContent>
                    <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        p: 3
                    }}>
                        <Typography variant="h6" sx={{ textAlign: 'center', mb: 3, fontWeight: 500 }}>
                            {getActionDetails().message}
                        </Typography>
                        
                        {/* Show the reason that was entered */}
                        <Box sx={{ 
                            width: '100%', 
                            backgroundColor: 'grey.50', 
                            p: 2, 
                            borderRadius: 1, 
                            border: '1px solid', 
                            borderColor: 'grey.300',
                            mb: 2
                        }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                                Reason:
                            </Typography>
                            <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                                "{reason}"
                            </Typography>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmationClose} color="inherit">
                        No
                    </Button>
                    <Button 
                        onClick={handleConfirmAction}
                        variant="contained"
                        color={getActionDetails().buttonColor}
                        disabled={isStatusUpdating}
                    >
                        {isStatusUpdating ? 'Processing...' : getActionDetails().buttonText}
                    </Button>
                </DialogActions>
            </Dialog>

            <ViewproductActionModal />
      </Grid>  

    )
}